import React, { useEffect, useState } from "react";
import Page from "../../components/general/page";
import PageHeader from "../../components/general/pageHeader/pageHeader";
import FulfilmentList from "../../components/fulfilments/list/index";
import HeaderFulfilmentImage from "../../assets/img/head-adempimenti.svg";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
  clearFulfilments,
  getFulfilments
} from "../../store/actions/fulfilments";
import { getCustomersWithoutFulfilmentId } from "../../store/actions/fulfilments/customers";
import { useLocation } from "react-router-dom";
import { useIntl } from "react-intl";

const FulfilmentView = props => {
  const {  pageRef } = props;
  const location = useLocation();
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const company = useSelector(state => state.company);
  const main = useSelector(state => state.main);
  const filteredCustomers = useSelector(state => state.fulfilments.filteredCustomers);

  const [firstLoaded, setFirstLoaded] = useState(false);

  const [companySel, setCompanySel] = useState(false);

  const [customerId, setCustomerId] = useState(null);

  const intl = useIntl();

  let cId = new URL(window.location.href.replace("#/", "")).searchParams.get("customerId");

  useEffect(() => {
    if (cId) {
      setCustomerId(cId);
    }
  }, []);

  useEffect(() => {
    dispatch(getCustomersWithoutFulfilmentId(auth, main.accountantUuidSelected)).then(res => {
      if (!cId) {
        dispatch(getFulfilments({ auth, managerId: main.accountantUuidSelected }));
      } else {
        const findCustomer = res.find(x => x.id === cId);
        if (findCustomer) {
          setCompanySel(company.companies.find(x => x.uuid === findCustomer.itemId));
          dispatch(getFulfilments({
            auth,
            managerId: main.accountantUuidSelected,
            itemId: findCustomer.itemId
          }));
        }
      }
    });

    return () => {
      dispatch(clearFulfilments());
      setFirstLoaded(false);
    };
  }, []);

  useEffect(() => {
    if (customerId && filteredCustomers) {
      const findCustomer = filteredCustomers.find(x => x.id === customerId);
      if (findCustomer) {
        setCompanySel(company.companies.find(x => x.uuid === findCustomer.itemId));
      }
    } else {
      setCompanySel(false);
    }
  }, [customerId]);

  useEffect(() => {
    
    if (location.search.length > 0) {
      setCustomerId(new URL(window.location.href.replace("#/", "")).searchParams.get("customerId"));
    } else {
      setCustomerId(null);
    }    
  }, [location.search]);

  const reloadData = () => {
    setFirstLoaded(false);
    dispatch(getFulfilments({ auth, managerId: main.accountantUuidSelected }));
  };

  const title = (
    <>
      <FormattedMessage id="fulfilments.headerTitle1" />
      <b>
        <FormattedMessage id="fulfilments.headerTitle2" />
      </b>
    </>
  );

  return (
    <Page
      pageRef={pageRef}      
      className={"contentStructure"}
      backUrl={companySel ? "/fulfilments" : null}
      backText={companySel ? <FormattedMessage id="actions.goBack" /> : null}
      title={
        !companySel ? (
          <FormattedMessage id="fulfilments.title" />
        ) : (
          <>
            <FormattedMessage id="fulfilments.title" />{" "}
            {companySel.ragioneSociale}
          </>
        )
      }
      subtitle={!companySel ? "" : `${intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" })} ${companySel.codiceFiscale}`}
    >
      {!customerId && (
        <PageHeader
          image={`${HeaderFulfilmentImage}`}
          isFulfilmentPage={true}
          title={title}
          subtitle={""}
          myType={main.myType}
        />
      )}
      {!customerId && <div className="headerSeparator"></div>}
      <FulfilmentList        
        firstLoaded={firstLoaded}
        setFirstLoaded={setFirstLoaded}
        reloadData={reloadData}
        customerId={customerId}
        customerItemId={companySel ? companySel.uuid : null}
        setCustomerId={setCustomerId}
      />
    </Page>
  );
};

export default FulfilmentView;
